import LegalLayout from "@/pages/legal/LegalLayout";
import { SITE } from "@/data/site";

export default function Shipping() {
  return (
    <LegalLayout
      testId="shipping-page"
      eyebrow="Legal"
      title="Shipping Policy"
      subtitle="Everything you need to know about how and when your Medina Lia order arrives."
      updated="June 2026"
      sections={[
        {
          heading: "Processing time",
          body: [
            "Orders are typically processed within 1–2 business days. Orders placed on weekends or holidays are processed the next business day. You will receive a confirmation once your order ships.",
          ],
        },
        {
          heading: "Shipping destinations & times",
          body: ["We currently ship across the United States. Estimated delivery times are:"],
          list: [
            "Standard shipping: 3–7 business days",
            "Expedited shipping: 2–3 business days (where available)",
            "Delivery times are estimates and may vary due to carrier delays",
          ],
        },
        {
          heading: "Shipping costs",
          body: [
            "Shipping costs are calculated at checkout based on your location and chosen method. From time to time we may offer free shipping promotions.",
          ],
        },
        {
          heading: "Order tracking",
          body: [
            "Once your order ships, you will receive a tracking number by email so you can follow your package every step of the way.",
          ],
        },
        {
          heading: "Delays & issues",
          body: [
            `If your order is delayed, lost or arrives damaged, please contact us at ${SITE.email} or ${SITE.phone} and we'll make it right.`,
          ],
        },
      ]}
    />
  );
}
